<template>
    <body class="c-app">
        <div class="c-wrapper">
            <div class="c-body">
                <main class="c-main" style="padding-top: 2rem">
                    <!-- <div class="container-fluid"> -->
                    <div class="" style="height: 100%;"> 
                        <div class="fade-in" style="height: 100%;">
                            <memberInsert></memberInsert>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    </body>
</template>

<script>
import memberInsert from '@/components/memberInsert/memberInsert.vue'

export default {
    name: '',
    components: 
    {
        memberInsert
    },
    data(){
        return {

        }
    },
    computed:
    {

    },
    watch: 
    {
    },
    methods:
    {

    },
    created: function()
    {
    },
    mounted: function()
    {
    },
}
</script>

<style>
.coreuiIcon
{
    filter:invert(100%);
    margin-top:-8px;
}
</style>